module.exports = __webpack_public_path__ + "static/media/vintage-women-1.e9c89a69.jpg";